import { useSelector } from "react-redux";

import { useVolumeActions } from "store/VolumeSlice";
import { DATA_VOLUME } from "utils/localStorage";

const usePersistVolume = (ref) => {
  const { volume } = useSelector((state) => state.VolumeSlice);
  const refVolume = () => ref?.current?.volume;
  const { setVolume: setVolumeS } = useVolumeActions();

  const init = () => {
    if (refVolume() != null && volume != null) {
      const videoPlayer = ref.current;
      if (videoPlayer?.volume) {
        videoPlayer.volume = volume;
      }
    }
  };
  const setVolume = () => {
    const refTemp = refVolume();
    setVolumeS(refTemp);
    sessionStorage.setItem(DATA_VOLUME, refTemp || volume);
  };

  return {
    setVolume,
    volume,
    init,
  };
};

export default usePersistVolume;
